export default function AnnouncementBar() {
  return null;
}
